import React from 'react';
import {Tooltip} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PropTypes from 'prop-types';

// the words shown on hover: dark text on white at the normal size, so it is easy to read (Maria, 20 October 2026)
export const HOVER_BOX = {
    tooltip: {
        sx: {
            backgroundColor: '#fff',
            color: '#000',
            fontSize: 14,
            fontWeight: 400,
            lineHeight: 1.5,
            maxWidth: 380,
            p: 1.5,
            border: '1px solid #cfd8e3',
            boxShadow: '0 4px 14px rgba(0, 0, 0, 0.15)'
        }
    },
    arrow: {sx: {color: '#fff', '&::before': {border: '1px solid #cfd8e3'}}}
};

// a green 'i' icon that shows an explanation on hover
const InfoHover = ({text, testId}) => (
    <Tooltip title={text} arrow placement="top" componentsProps={HOVER_BOX}>
        <InfoOutlinedIcon fontSize="small" sx={{color: '#0A8572', cursor: 'help'}} data-testid={testId}/>
    </Tooltip>
);

InfoHover.propTypes = {
    text: PropTypes.node.isRequired,
    testId: PropTypes.string
};

export default InfoHover;
